<!-- CUSTOM TOASTER ALERT STYLE -->
@if (display.customToasterAlert) {
<div class="toaster rounded-md px-18px py-15px text-black w-fit max-w-2xl z-50" [ngClass]="{
			'bg-warning': display.warning,
			'bg-success': display.success,
			'bg-danger': display.error,
			'bg-info':display.info
		}">
    <div class="flex items-center">
      <div class="shrink-0 self-start">
        <svg class="text-black" width="24" height="24" aria-hidden="true">
          @if (display.warning) {
            <use xlink:href="#icon-warning" />
          }
          @if (display.success) {
            <use xlink:href="#icon-check-circle" />
          }
          @if (display.error) {
            <use xlink:href="#icon-cross-circle" />
          }
          @if (display.info) {
            <use xlink:href="#icon-info" />
          }
        </svg>
      </div>
      <div class="ml-12px">
        <div class="text-16 leading-normal font-medium" [innerHTML]="display.message"></div>
      </div>
    </div>
  </div>
}

<!-- CUSTOM TOASTER NOTIFICATION STYLE -->
@if (display.customToasterNotification) {
  <div class="toaster rounded-lg bg-gray-onyx/85 backdrop-blur-md p-34px text-white w-fit max-w-2xl z-50"
    role="alert" >
    <div class="flex items-center">
      <div class="shrink-0 self-start">
			<svg width="30" height="30" aria-hidden="true" [ngClass]="{
								'text-warning': display.warning,
								'text-success': display.success,
								'text-danger': display.error,
								'text-info':display.info
								}">
          @if (display.warning) {
            <use xlink:href="#icon-warning" />
          }
          @if (display.success) {
            <use xlink:href="#icon-check-circle" />
          }
          @if (display.error) {
            <use xlink:href="#icon-cross-circle" />
          }
          @if (display.info) {
            <use xlink:href="#icon-info" />
          }
        </svg>
      </div>
      <div class="ml-22px">
        <h3 class="text-18 leading-6 font-display font-medium" [attr.aria-label]="display.title">{{display.title}}</h3>
        @if (!display.customLinkActivity) {
          <div class="mt-14px text-16 leading-6 text-white/60" [innerHTML]="display.message" tabindex="0" (click)="processLinks($event)" (keypress.enter)="processLinks($event)"></div>
        }
        @if (display.customLinkActivity) {
          <div class="mt-14px text-16 leading-6 text-white/60">
            {{display.message}}	Click <a class="btn-text" [routerLink]="activityPath"> here </a> or on the activity icon '<svg class="inline" width="18" height="18"><use xlink:href="#icon-activity"/></svg>' at the top right corner to track progress.
          </div>
        }
        <div class="mt-18px flex items-center gap-20px">
          @if (display.customActionViewDetails) {
            <button type="button" class="btn-text text-primary" (click)="viewDetails()"> View Details </button>
          }
          @if (display.customActionViewSummary) {
            <button type="button" class="btn-text text-primary" (click)="viewSummary()"> View Summary </button>
          }
          @if (display.customActionViewRequests) {
            <button type="button" class="btn-text text-primary" (click)="viewRequests()"> View Request </button>
          }
          @if (display.customActionViewReports) {
            <button type="button" class="btn-text text-primary" (click)="viewReports()"> View Report </button>
          }
          @if (display.customActionRetryTenantScan) {
            <button type="button" class="btn-text text-primary" (click)="retryTenantScan()"> Retry Scan </button>
          }
          @if (display.customActionOpenDashboardPulse) {
            <button type="button" class="btn-text text-primary" (click)="openDashBoard('pulse')"> Dashboard </button>
          }
          @if (display.customActionOpenDashboardIntranet) {
            <button type="button" class="btn-text text-primary" (click)="openDashBoard('intranet')"> Dashboard </button>
          }
          @if (display.customActionContactSupport) {
            <button type="button" class="btn-text text-primary" (click)="contactSupport()"> Contact Support </button>
          }
          @if (display.customActionOpenPricing) {
            <button type="button" class="btn-text text-primary" (click)="openPricing()"> Upgrade to Full Licence </button>
          }
          @if (display.customActionOpenOrphanedWorkspaces) {
            <button type="button" class="btn-text text-primary" (click)="openOrphanedWorkspacesReport()"> Open Report </button>
          }
          <button type="button" class="btn-text text-primary" (click)="remove()"> Dismiss </button>
        </div>
      </div>
    </div>
  </div>
}

